var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Loading } from 'element-ui';
import { Component, Prop } from 'vue-property-decorator';
import GlobalVue from "../../globalVue";
import LicenseAddEditDialog from './LicenseAddEditDialog.vue';
import LicenseDetailDialog from './LicenseDetailDialog.vue';
import LicenseTypeDialog from './LicenseTypeDialog.vue';
import LicenseService from "../../api/LicenseService";
import Header from "./components/Header.vue";
import AddGoods from './components/addGoodsCol2/AddGoods';
import AddClient from './components/addClientCol2/AddClient';
import SeeBindCustomers from './SeeBindCustomers';
import SeeBindGoods from './SeeBindGoods';
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
var LicenseList = (function (_super) {
    __extends(LicenseList, _super);
    function LicenseList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.companyInfo = {};
        _this.dialogVisible = false;
        _this.tableData = [];
        _this.selectedData = [];
        _this.total = 0;
        return _this;
    }
    LicenseList.prototype.created = function () {
        this.order = this.porder;
        this.service = LicenseService.getInstance();
        this.getCompanyInfo();
    };
    LicenseList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 160 - 40;
            }
        }, 300);
        this.etimeSortEvent = function () {
            _this.order = ["document_etime", "asc"];
            _this.getLicenseList();
        };
        GlobalVue.$on('LicenseManage:etimeSort', this.etimeSortEvent);
    };
    LicenseList.prototype.destroyed = function () {
        GlobalVue.$off('LicenseManage:etimeSort', this.etimeSortEvent);
    };
    LicenseList.prototype.getCompanyInfo = function () {
        var _this = this;
        this.service.getCompanyInfo().then(function (res) {
            if (res.data.success) {
                _this.companyInfo = res.data.data;
            }
        });
    };
    LicenseList.prototype.selectionChange = function (val) {
        this.selectedData = val;
    };
    LicenseList.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        this.filter = filter;
        this.getLicenseList();
    };
    LicenseList.prototype.getLicenseList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var params = {
            sort_field: this.order ? this.order[0] : undefined,
            sort_type: this.order ? this.order[1] : undefined
        };
        Object.assign(params, this.filter, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getLicenseList(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.tableData = res.data.data;
                _this.total = res.data.total;
                window._czc.push(["_trackEvent", '证照类型', '查询']);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    LicenseList.prototype.pageChange = function () {
        this.getLicenseList();
    };
    LicenseList.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getLicenseList();
    };
    LicenseList.prototype.addLicese = function () {
        var _this = this;
        var instance = this.$dialog(LicenseAddEditDialog, {
            data: {
                company_name: this.$store.state.config.company_name
            }
        }, {
            title: "添加证照",
            width: 710,
            height: "80%"
        }).instance;
        instance.$on("add_liscense:ok", function () {
            window._czc.push(["_trackEvent", '证照列表', '添加证照']);
            _this.getLicenseList();
        });
    };
    LicenseList.prototype.editLicense = function (row) {
        var _this = this;
        var instance = this.$dialog(LicenseAddEditDialog, {
            data: {
                document_id: row.document_id
            }
        }, {
            title: "编辑证照",
            width: 710,
            height: "80%"
        }).instance;
        instance.$on("edit_liscense:ok", function () {
            window._czc.push(["_trackEvent", '证照列表', '编辑证照']);
            _this.getLicenseList();
        });
    };
    LicenseList.prototype.lookLicense = function (row) {
        var instance = this.$dialog(LicenseDetailDialog, {
            data: {
                document_id: row.document_id
            }
        }, {
            title: "查看证照",
            width: 700,
            height: "80%"
        }).instance;
        window._czc.push(["_trackEvent", '证照列表', '查看证照']);
    };
    LicenseList.prototype.delLicense = function (row) {
        var _this = this;
        this.dialogVisible = true;
        var title = row.bind_num > 0 ? "该证照已绑定客户或货品，删除证照时，将一并解绑其关系。请确认是否删除？" : "此操作将永久删除该证照, 是否继续?";
        this.$confirm(title, "提示", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function (res) {
            if (res) {
                _this.service.delete({ document_id: row.document_id }).then(function (res) {
                    if (res.data.success) {
                        _this.$message.success('删除成功!');
                        _this.getLicenseList();
                    }
                    else {
                        _this.$message.error(res.data.msg);
                    }
                    window._czc.push(["_trackEvent", '证照列表', '删除证照']);
                });
            }
        }).catch(function () { });
    };
    LicenseList.prototype.seeLiceseType = function () {
        var instance = this.$dialog(LicenseTypeDialog, {
            data: {}
        }, {
            title: "证照类型",
            width: 710,
            height: 520
        }).instance;
        instance.$on("save_liscense_type:ok", function () {
            window._czc.push(["_trackEvent", '证照列表', '证照类型']);
        });
    };
    LicenseList.prototype.bindGoods = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            var loadingInstance, addedDatas, addedFormatDatas, dialog;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loadingInstance = Loading.service({ fullscreen: true });
                        return [4, this.getAlreadyBindGoods(row.document_id, 1)];
                    case 1:
                        addedDatas = _a.sent();
                        return [4, this.getAlreadyBindGoods(row.document_id, 2)];
                    case 2:
                        addedFormatDatas = _a.sent();
                        loadingInstance.close();
                        dialog = this.$dialog(AddGoods, {
                            data: {
                                addedDatas: addedDatas,
                                addedFormatDatas: addedFormatDatas,
                                tabTableComponent: 'license-bind-goods-tab-table'
                            }
                        }, {
                            title: "绑定货品",
                            width: 950,
                            height: 500
                        });
                        dialog.instance.$on("save:ok", function (res, dimension) {
                            if (res.length == 0) {
                                _this.$message.warning('请至少选择一个货品');
                                return;
                            }
                            if (dimension === 1) {
                                var goods_ids = res.map(function (v) { return v.goods_id; });
                                var params = {
                                    document_id: row.document_id,
                                    goods_ids: goods_ids.join(',')
                                };
                                _this.bindGoodsAjax(params, dialog, 'documentBindGoods');
                            }
                            else {
                                var goods_format_ids = res.map(function (v) { return v.goods_format_id; });
                                var params = {
                                    document_id: row.document_id,
                                    goods_format_ids: goods_format_ids.join(',')
                                };
                                _this.bindGoodsAjax(params, dialog, 'documentBindGoodsFormat');
                            }
                        });
                        return [2];
                }
            });
        });
    };
    LicenseList.prototype.bindGoodsAjax = function (params, dialog, apiFunction) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service[apiFunction](params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                if (res.data.code == 46) {
                    var instance = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        }
                    }, {
                        title: "提示",
                        width: 450,
                        height: 350
                    }).instance;
                    instance.$on("artMsglist:ok", function (data) {
                        var confirm = res.data.data[0].confirm;
                        _this.bindGoodsAjax(__assign({}, params, { confirm: confirm }), dialog, apiFunction);
                    });
                }
                else {
                    _this.$message.success('绑定货品成功!');
                    dialog.instance.close();
                    _this.getLicenseList();
                }
            }
            else {
                loadingInstance.close();
                _this.$message.error(res.data.msg);
            }
            window._czc.push(["_trackEvent", '证照列表', '绑定货品']);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    LicenseList.prototype.getAlreadyBindGoods = function (document_id, dimension) {
        return __awaiter(this, void 0, void 0, function () {
            var result, params;
            var _this = this;
            return __generator(this, function (_a) {
                result = [];
                params = {
                    page: 1,
                    start: 0,
                    limit: 2000
                };
                Object.assign(params, { document_id: document_id, dimension: dimension });
                return [2, this.service.getDocumentAlreadyBindGoods(params).then(function (res) {
                        if (res.data.success) {
                            result = res.data.data;
                        }
                        else {
                            _this.$message.error(res.data.msg);
                        }
                        return result;
                    })];
            });
        });
    };
    LicenseList.prototype.bindCustomers = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            var loadingInstance, addedDatas, dialog;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loadingInstance = Loading.service({ fullscreen: true });
                        return [4, this.getAlreadyBindBusiness(row.document_id)];
                    case 1:
                        addedDatas = _a.sent();
                        loadingInstance.close();
                        dialog = this.$dialog(AddClient, {
                            data: {
                                addedDatas: addedDatas
                            }
                        }, {
                            title: "绑定客户",
                            width: 950,
                            height: 500
                        });
                        dialog.instance.$on("save:ok", function (res) {
                            if (res.length == 0) {
                                _this.$message.warning('请至少选择一个客户');
                                return;
                            }
                            var business_ids = res.map(function (v) { return v.business_id; });
                            var params = {
                                document_id: row.document_id,
                                business_ids: business_ids.join(',')
                            };
                            _this.bindCustomersAjax(params, dialog);
                        });
                        return [2];
                }
            });
        });
    };
    LicenseList.prototype.bindCustomersAjax = function (params, dialog) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.documentBindBusiness(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                if (res.data.code == 46) {
                    var instance = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        }
                    }, {
                        title: "提示",
                        width: 450,
                        height: 350
                    }).instance;
                    instance.$on("artMsglist:ok", function (data) {
                        var confirm = res.data.data[0].confirm;
                        _this.bindCustomersAjax(__assign({}, params, { confirm: confirm }), dialog);
                    });
                }
                else {
                    _this.$message.success('绑定客户成功!');
                    dialog.instance.close();
                    _this.getLicenseList();
                }
            }
            else {
                loadingInstance.close();
                _this.$message.error(res.data.msg);
            }
            window._czc.push(["_trackEvent", '证照列表', '绑定客户']);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    LicenseList.prototype.getAlreadyBindBusiness = function (document_id) {
        return __awaiter(this, void 0, void 0, function () {
            var result, params;
            var _this = this;
            return __generator(this, function (_a) {
                result = [];
                params = {
                    page: 1,
                    start: 0,
                    limit: 2000
                };
                Object.assign(params, { document_id: document_id });
                return [2, this.service.getDocumentAlreadyBindBusiness(params).then(function (res) {
                        if (res.data.success) {
                            result = res.data.data;
                        }
                        else {
                            _this.$message.error(res.data.msg);
                        }
                        return result;
                    })];
            });
        });
    };
    LicenseList.prototype.seeBindGoods = function (row) {
        GlobalVue.$emit('addTab', {
            component: SeeBindGoods,
            opener: this,
            title: '查看绑定货品',
            showExist: true,
            name: 'license-see-bind-goods' + row.document_id,
            cprops: {
                row: row,
                document_id: row.document_id
            }
        });
    };
    LicenseList.prototype.seeBindCustomers = function (row) {
        GlobalVue.$emit('addTab', {
            component: SeeBindCustomers,
            opener: this,
            title: '查看绑定客户',
            showExist: true,
            name: 'license-see-bind-customers' + row.document_id,
            cprops: {
                row: row,
                document_id: row.document_id
            }
        });
    };
    LicenseList.prototype.syncLicese = function () {
        var _this = this;
        if (!this.selectedData.length) {
            this.$message.error("请选择证照");
            return;
        }
        var document_ids = this.selectedData.map(function (v) { return v.document_id; });
        var params = {
            document_ids: document_ids.join(',')
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.documentManualSync(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.$message.success(res.data.msg || "手动同步成功");
                _this.getLicenseList();
                window._czc.push(["_trackEvent", '证照管理', '手动同步']);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    __decorate([
        Prop({
            type: Array
        })
    ], LicenseList.prototype, "porder", void 0);
    LicenseList = __decorate([
        Component({
            components: {
                'list-header': Header
            },
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData'
            }))
        })
    ], LicenseList);
    return LicenseList;
}(Vue));
export default LicenseList;
